import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import paymentService from "services/paymentService";

const toMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

export default function useBusinessGrowthPartners() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState({ totalElements: 0, totalPages: 1 });

  const list = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await paymentService.businessGrowthPartners.list(params);
      const content = Array.isArray(res?.content) ? res.content : [];
      setPartners(content);
      setPage({
        totalElements: res?.totalElements ?? content.length,
        totalPages: res?.totalPages ?? 1,
      });
      return res;
    } catch (err) {
      const message = toMessage(err, "Failed to load growth partners");
      setError(message);
      toast.error(message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (payload, actorId) => {
    try {
      const res = await paymentService.businessGrowthPartners.create(payload, actorId);
      toast.success("Growth partner created");
      return res;
    } catch (err) {
      toast.error(toMessage(err, "Failed to create growth partner"));
      throw err;
    }
  }, []);

  const update = useCallback(async (id, payload, actorId) => {
    try {
      const res = await paymentService.businessGrowthPartners.update(id, payload, actorId);
      toast.success("Growth partner updated");
      return res;
    } catch (err) {
      toast.error(toMessage(err, "Failed to update growth partner"));
      throw err;
    }
  }, []);

  const cancel = useCallback(async (id, statusReason, actorId) => {
    try {
      await paymentService.businessGrowthPartners.cancel(id, { statusReason }, actorId);
      toast.success("Growth partner cancelled");
    } catch (err) {
      toast.error(toMessage(err, "Failed to cancel growth partner"));
      throw err;
    }
  }, []);

  return { partners, loading, error, page, list, create, update, cancel };
}
